<template>
    <div>
        <apply-ticket-note-template-modal @apply-template="applyTemplate"></apply-ticket-note-template-modal>
        <loading-screen :is-loading="isSaving"></loading-screen>
        <errors :error-list="serverErrors"></errors>
        <!-- Description -->
        <div class="card shadow-none card-action">
            <div class="card-header">
                <div class="avatar-xxs d-inline-block mr-3">
                            <span class="avatar-title rounded bg-soft-primary text-primary font-size-14">
                                {{ $auth.user.name.charAt(0) }}
                            </span>
                </div>
                <b class="d-inline-block">Create Note</b>
            </div>
            <div class="card-body pb-0">
                <editor-content :editor="editor"/>
                <!-- Suggestions -->
                <div class="suggestion-list" v-show="showSuggestions" ref="suggestions">
                    <template v-if="hasResults">
                        <div
                                v-for="(user, index) in filteredUsers"
                                :key="user.id"
                                class="suggestion-list__item"
                                :class="{ 'is-selected': navigatedUserIndex === index }"
                                @click="selectUser(user)"
                        >
                            {{ user.name }}
                        </div>
                    </template>
                    <div v-else class="suggestion-list__item is-empty">
                        No users found
                    </div>
                </div>
                <!-- / Suggestions -->
            </div>
            <div class="card-menubar">
                <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
                    <div class="menubar">

                        <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                           :class="{ 'is-active': isActive.bold() }"
                           @click="commands.bold"
                        >
                            <i class="fas fa-bold"></i>
                        </a>

                        <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                           :class="{ 'is-active': isActive.italic() }"
                           @click="commands.italic"
                        >
                            <i class="fas fa-italic"></i>
                        </a>

                        <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                           :class="{ 'is-active': isActive.strike() }"
                           @click="commands.strike"
                        >
                            <i class="fas fa-strikethrough"></i>
                        </a>

                        <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                           :class="{ 'is-active': isActive.underline() }"
                           @click="commands.underline"
                        >
                            <i class="fas fa-underline"></i>
                        </a>

                        <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                           :class="{ 'is-active': isActive.bullet_list() }"
                           @click="commands.bullet_list"
                        >
                            <i class="fas fa-list-ul"></i>
                        </a>

                        <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                           :class="{ 'is-active': isActive.ordered_list() }"
                           @click="commands.ordered_list"
                        >
                            <i class="fas fa-list-ol"></i>
                        </a>

                        <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                           @click="commands.undo"
                        >
                            <i class="fas fa-undo"></i>
                        </a>

                        <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                           @click="commands.redo"
                        >
                            <i class="fas fa-redo"></i>
                        </a>

                        <a @click.prevent="openMediaUploader"
                         href="#" class="btn btn-itg-white btn-sm menubar__button">
                            <i class="fas fa-images"></i>
                        </a>
                        <upload-media-modal @file-uploaded="r => handleFileUploaded(r, commands.image)"
                        :ticket-id="ticket.id" modal-id="create-ticket-note-upload-media-modal"></upload-media-modal>

                        <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                           @click="openApplyTicketNoteTemplateModal"
                        >
                            <i class="fas fa-paste"></i> Template
                        </a>
                    </div>
                </editor-menu-bar>
            </div>
            <div class="card-footer text-right">
                <button type="button" class="btn btn-itg mr-2" @click="attemptCancel">
                    Cancel
                </button>

                <button type="button" class="btn btn-itg-dark" @click="saveNote">
                    Add note
                </button>
            </div>
        </div>
        <!-- / Description -->

    </div>
</template>

<script>
    import {mapGetters, mapActions} from "vuex";
    import Forms from "../../../../../mixins/Forms";
    import Fuse from 'fuse.js';
    import tippy, {sticky} from 'tippy.js';
    import ApplyTicketNoteTemplateModal from "./CreateTicketNote/ApplyTicketNoteTemplateModal";
    import UploadMediaModal from './UploadMediaModal.vue';
    import axios from 'axios';

    import {Editor, EditorContent, EditorMenuBar} from 'tiptap';
    import {
        Blockquote,
        CodeBlock,
        HardBreak,
        Heading,
        OrderedList,
        BulletList,
        ListItem,
        TodoItem,
        TodoList,
        Bold,
        Code,
        Italic,
        Link,
        Strike,
        Underline,
        History, Mention,
        Image
    } from 'tiptap-extensions';

    export default {
        name: "CreateTicketNote",
        data() {
            return {
                isSaving: false,
                serverErrors: [],
                value: null,
                editor: null,

                query: null,
                suggestionRange: null,
                filteredUsers: [],
                navigatedUserIndex: 0,
                insertMention: () => {
                }
            }
        },

        beforeDestroy() {
            this.destroyPopup()
        },

        computed: {
            ...mapGetters('ticketViewer', {
                ticket: 'ticket',
                agents: 'agents'
            }),

            hasResults() {
                return this.filteredUsers.length;
            },
            showSuggestions() {
                return this.query || this.hasResults;
            }
        },
        mounted() {
            this.setupEditor();
        },
        components: {EditorMenuBar, EditorContent, ApplyTicketNoteTemplateModal, UploadMediaModal},
        mixins: [Forms],
        methods: {
            ...mapActions('ticketViewer', {
                cancelAction: 'cancelAction',
                actionComplete: 'actionComplete',
                loadMedia: 'loadMedia'
            }),

            saveNote() {
                let vm = this;
                let editorHtml = vm.editor.getHTML();
                let idsOfUsersMentioned = this.getMentionIdsFromHtml(editorHtml);

                vm.isSaving = true;
                vm.serverErrors = [];
                axios.post(API_BASE + '/tickets/' + this.ticket.id + '/notes', {
                    body: editorHtml,
                    ids_of_users_mentioned: idsOfUsersMentioned
                }).then(r => {
                    vm.isSaving = false;
                    this.actionComplete();
                }).catch(e => {
                    vm.isSaving = false;
                    vm.setErrors(e);
                });
            },

            attemptCancel() {
                let vm = this;
                swal({
                    title: "Are you sure you want to cancel?",
                    text: "You have unsaved changes and your data will be lost.",
                    icon: "warning",
                    buttons: {
                        cancel: true,
                        confirm: "Leave without saving"
                    },
                    dangerMode: true,
                }).then((shouldCancel) => {
                    if (shouldCancel) {
                        vm.cancelAction();
                    }
                });
            },

            setupEditor() {
                let vm = this;
                this.editor = new Editor({
                    extensions: [
                        new Blockquote(),
                        new CodeBlock(),
                        new HardBreak(),
                        new Heading({levels: [1, 2, 3]}),
                        new BulletList(),
                        new OrderedList(),
                        new ListItem(),
                        new TodoItem(),
                        new TodoList(),
                        new Bold(),
                        new Code(),
                        new Italic(),
                        new Link(),
                        new Strike(),
                        new Underline(),
                        new History(),
                        new Image(),
                        new Mention({
                            // a list of all suggested items
                            items: async () => {
                                await new Promise(resolve => {
                                    setTimeout(resolve, 500)
                                })
                                return vm.agents;
                            },
                            // is called when a suggestion starts
                            onEnter: ({
                                          items, query, range, command, virtualNode,
                                      }) => {
                                this.query = query
                                this.filteredUsers = items
                                this.suggestionRange = range
                                this.renderPopup(virtualNode)
                                // we save the command for inserting a selected mention
                                // this allows us to call it inside of our custom popup
                                // via keyboard navigation and on click
                                this.insertMention = command
                            },
                            // is called when a suggestion has changed
                            onChange: ({
                                           items, query, range, virtualNode,
                                       }) => {
                                this.query = query
                                this.filteredUsers = items
                                this.suggestionRange = range
                                this.navigatedUserIndex = 0
                                this.renderPopup(virtualNode)
                            },
                            // is called when a suggestion is cancelled
                            onExit: () => {
                                // reset all saved values
                                this.query = null
                                this.filteredUsers = []
                                this.suggestionRange = null
                                this.navigatedUserIndex = 0
                                this.destroyPopup()
                            },
                            // is called on every keyDown event while a suggestion is active
                            onKeyDown: ({event}) => {
                                if (event.key === 'ArrowUp') {
                                    this.upHandler()
                                    return true
                                }
                                if (event.key === 'ArrowDown') {
                                    this.downHandler()
                                    return true
                                }
                                if (event.key === 'Enter') {
                                    this.enterHandler()
                                    return true
                                }
                                return false
                            },
                            // is called when a suggestion has changed
                            // this function is optional because there is basic filtering built-in
                            // you can overwrite it if you prefer your own filtering
                            // in this example we use fuse.js with support for fuzzy search
                            onFilter: async (items, query) => {
                                if (!query) {
                                    return items
                                }
                                await new Promise(resolve => {
                                    setTimeout(resolve, 500)
                                })
                                const fuse = new Fuse(items, {
                                    threshold: 0.2,
                                    keys: ['name'],
                                })
                                return fuse.search(query).map(item => item.item)
                            },
                        })
                    ],
                    content: this.value,
                    autoFocus: true,
                    onInit: function () {
                        vm.$nextTick(function () {
                            window.setTimeout(function () {
                                let container = document.getElementById('ticket-main-section-left-column');
                                container.scrollTo({
                                    top: container.scrollHeight,
                                    behavior: "smooth",
                                    cancelable: false
                                });
                            }, 1);
                        });
                    }
                })
            },

            openApplyTicketNoteTemplateModal() {
                this.$bvModal.show('apply-ticket-note-template-modal');
            },

            applyTemplate(template) {
                this.$bvModal.hide('apply-ticket-note-template-modal');
                this.editor.setContent(template.body);
            },

            // navigate to the previous item
            // if it's the first item, navigate to the last one
            upHandler() {
                this.navigatedUserIndex = ((this.navigatedUserIndex + this.filteredUsers.length) - 1) % this.filteredUsers.length
            },
            // navigate to the next item
            // if it's the last item, navigate to the first one
            downHandler() {
                this.navigatedUserIndex = (this.navigatedUserIndex + 1) % this.filteredUsers.length
            },
            enterHandler() {
                const user = this.filteredUsers[this.navigatedUserIndex]
                if (user) {
                    this.selectUser(user)
                }
            },
            // we have to replace our suggestion text with a mention
            // so it's important to pass also the position of your suggestion text
            selectUser(user) {
                this.insertMention({
                    range: this.suggestionRange,
                    attrs: {
                        id: user.id,
                        label: user.name,
                    },
                })
                this.editor.focus()
            },
            // renders a popup with suggestions
            // tiptap provides a virtualNode object for using popper.js (or tippy.js) for popups
            renderPopup(node) {
                const boundingClientRect = node.getBoundingClientRect()
                const {x, y} = boundingClientRect
                if (x === 0 && y === 0) {
                    return
                }
                if (this.popup) {
                    return
                }
                // ref: https://atomiks.github.io/tippyjs/v6/all-props/
                this.popup = tippy('#app', {
                    getReferenceClientRect: () => boundingClientRect,
                    appendTo: () => document.body,
                    interactive: true,
                    sticky: true, // make sure position of tippy is updated when content changes
                    plugins: [sticky],
                    content: this.$refs.suggestions,
                    trigger: 'mouseenter', // manual
                    showOnCreate: true,
                    theme: 'dark',
                    placement: 'top-start',
                    inertia: true,
                    duration: [400, 200],
                })
            },
            destroyPopup() {
                if (this.popup) {
                    this.popup[0].destroy()
                    this.popup = null
                }
            },
            openMediaUploader() {
                this.$bvModal.show('create-ticket-note-upload-media-modal');
            },
            handleFileUploaded(r, imgCommand) {
                this.loadMedia();
                let url = r['url'];
                this.$bvModal.hide('create-ticket-note-upload-media-modal');
                if (url) {
                    imgCommand({src: url});
                }
            }
        }
    }
</script>

<style scoped>
    .card {
        background-color: #f5f7f9;
    }
</style>
